import { render, staticRenderFns } from "./paired.vue?vue&type=template&id=ac45daa8&scoped=true"
import script from "./paired.vue?vue&type=script&lang=js"
export * from "./paired.vue?vue&type=script&lang=js"
import style0 from "./paired.vue?vue&type=style&index=0&id=ac45daa8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac45daa8",
  null
  
)

export default component.exports